import UploadButton from './UploadButton';

const View = ({ path }) => {
  return <UploadButton path={path} />;
};

export default View;
